import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ProGallery } from 'pro-gallery';
import { getResizeMediaUrl } from '@wix/native-pro-gallery-utils';
import '../../assets/styles/gallery.global.scss';
export const WixProGalleryBase = _ref => {
  let {
    id,
    container,
    options,
    customComponents,
    isPrerenderMode,
    eventsListener,
    isAccessible,
    staticMediaUrls,
    // TODO, these replace the hardcoded wixstatic urls. they should be provided by the platform.
    children,
    styles,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "pro-gallery-wix-wrapper",
    style: styles
  }, /*#__PURE__*/React.createElement(ProGallery, _extends({}, props, {
    id,
    options,
    container,
    // @ts-expect-error
    createMediaUrl: getResizeMediaUrl({
      staticMediaUrls,
      isPrerenderMode
    }),
    settings: {
      isAccessible
    },
    eventsListener,
    isPrerenderMode,
    customComponents
  })), children);
};
//# sourceMappingURL=gallery.js.map